import { Component, OnInit } from '@angular/core';
import { InvoiceService } from 'src/app/services/invoice/invoice.service';

@Component({
  selector: 'app-vendornavinvoice',
  templateUrl: './vendornavinvoice.component.html',
  styleUrls: ['./vendornavinvoice.component.css']
})
export class VendornavinvoiceComponent implements OnInit {

  data: any;

  constructor(private invoiceServices: InvoiceService) { }

  ngOnInit() {
    this.getVendorPaidInvoiceList();
  }

  getVendorPaidInvoiceList() {
    this.invoiceServices.getVendorPaidInvoiceList().subscribe(
      (data: any) => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  // syncNavPaidInvoice() {
  //   this.invoiceServices.syncNavPaidInvoice().subscribe(
  //     (data: any) => {
  //       alert("data synchronized");
  //       this.getNavPaidInvoice();
  //     }
  //   )
  // }

}
